import { H3, P } from '../../../AbstractElements';
import React, { Fragment } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import i18n from '../../../i18n';


const ProfileGreeting = () => {
    return (
        <Fragment>
            <Card className="profile-greeting">
                <CardHeader className="pb-0"></CardHeader>
                <CardBody className="text-center p-t-0">
                    <H3 attrH3={{ className: 'font-light' }} >{i18n.t('Dashboard_Greeting_Title')}</H3>
                    <P>{i18n.t('Dashboard_Greeting_Subtitle')}</P>
                </CardBody>
                <div className="confetti">
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                    <div className="confetti-piece"></div>
                </div>
            </Card>
        </Fragment>
    );
};

export default ProfileGreeting;
